var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgU15(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "4 copy 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "4-copy-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-124",
    stroke: "#292929"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.0086957,1.5 C54.975194,1.5 55.850194,1.89175084 56.4835694,2.52512627 C57.1169448,3.15850169 57.5086957,4.03350169 57.5086957,5 L57.5086957,5 L57.5086957,13.3823088 L43.8211462,13.8823088 L43.8211462,1.5 L54.0086957,1.5 Z",
    id: "\\u77E9\\u5F62",
    strokeWidth: 3,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.943,1.5 L48.8912277,1.55848613 C47.4178236,3.27746924 46.6043478,5.46967475 46.6043478,7.74079877 L46.6043478,7.74079877 L46.6043478,55 C46.6043478,55.9664983 46.212597,56.8414983 45.5792216,57.4748737 C44.9458461,58.1082492 44.0708461,58.5 43.1043478,58.5 L43.1043478,58.5 L5,58.5 C4.03350169,58.5 3.15850169,58.1082492 2.52512627,57.4748737 C1.89175084,56.8414983 1.5,55.9664983 1.5,55 L1.5,55 L1.5,9.57301061 C1.5,7.34371028 2.40360249,5.32545763 3.86453006,3.86453006 C5.32545763,2.40360249 7.34371028,1.5 9.57301061,1.5 L9.57301061,1.5 L48.943,1.5 Z",
    id: "\\u77E9\\u5F62",
    strokeWidth: 3,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8815485,14.8324955 L22.4467659,12.6903386 C22.9091963,12.5123405 23.4212385,12.5123405 23.8836689,12.6903386 L29.4488863,14.8324955 C30.2210115,15.129701 30.7304348,15.8716465 30.7304348,16.6989969 L30.7304348,21.8230561 C30.4964403,26.24156 27.9747012,28.8502557 23.1652174,29.6491431 C18.5421758,28.7109412 16.0204367,26.1022456 15.6,21.8230561 L15.6,21.8230561 L15.6,16.6989969 C15.6,15.8716465 16.1094232,15.129701 16.8815485,14.8324955 Z",
    id: "\\u77E9\\u5F62",
    strokeWidth: 2.2,
    fill: "#2B6EFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4",
    transform: "translate(9.600000, 38.275862)",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("line", {
    x1: 8.85717831e-14,
    y1: 0.652173913,
    x2: 1.44264683,
    y2: 0.652173913,
    id: "\\u8DEF\\u5F84-40"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.2,
    y1: 0.652173913,
    x2: 27.6861251,
    y2: 0.652173913,
    id: "\\u8DEF\\u5F84-40"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 8.4,
    y1: 46.1694153,
    x2: 37.5395603,
    y2: 46.1694153,
    id: "\\u8DEF\\u5F84-40",
    strokeWidth: 3,
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgU15);
export default __webpack_public_path__ + "static/media/u15.bbe03bdff74aea96ea0509182f498a09.svg";
export { ForwardRef as ReactComponent };